/**
 * useOpenTutorSupport — ouvrir le WhatsApp de l'équipe : l'adresse donnée par l'appelant (celle d'un
 * refus du serveur), sinon celle de `static-data`, sinon celle de l'ancien accueil.
 */
import { useCallback } from "react"
import { useSelector } from "react-redux"

import { SUPPORT_WHATSAPP_FALLBACK } from "../../../adapters/tutor/shared/tutorLinks"
import { openExternalUrl } from "../../hooks/openExternalUrl"

export function useOpenTutorSupport(): (url?: string | null) => void {
    const staticUrl = useSelector(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state: any) => (state?.data?.staticData?.support_whatsapp_url as string | null | undefined) ?? null
    )
    return useCallback(
        (url?: string | null) => openExternalUrl(url || staticUrl || SUPPORT_WHATSAPP_FALLBACK),
        [staticUrl]
    )
}
